import React, {useEffect} from 'react';
import AppSpinner from "../../components/spinner/spinner";
import {useSelector} from "react-redux";
import {RootState} from "../../store";

const Awaiting = () => {
  const initComplete = useSelector((state: RootState) => state.app.initComplete)

  useEffect(() => {
    if(initComplete) {
      setTimeout(() => {window.location.assign('/authenticate/login')}, 2000);
    }
  }, [initComplete])

  return (
    <AppSpinner/>
  );
};

export default Awaiting;
